import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, assetUrl } from "@/lib/api";
import { ArticleRow, SectionTitle } from "@/components/ArticleCards";

export default function IssueDetail() {
  const { id } = useParams();
  const [iss, setIss] = useState(null);
  useEffect(() => { api.get(`/issues/${id}`).then((r) => setIss(r.data)).catch(() => {}); }, [id]);
  if (!iss) return <div className="py-24 text-center font-serif text-[#001F3F]/60">Loading…</div>;
  return (
    <div className="py-16 md:py-24" data-testid="issue-detail-page">
      <div className="max-w-4xl mx-auto px-6">
        <SectionTitle subtitle={`Volume ${iss.volume}, Issue ${iss.issue} — ${iss.year}`}>
          {iss.title || "Issue"}
        </SectionTitle>
        {iss.cover_image_url && (
          <div className="flex justify-center mb-10">
            <img src={assetUrl(iss.cover_image_url)} alt="" className="max-h-80 border border-gray-200" />
          </div>
        )}
        {iss.description && <p className="font-serif text-base text-[#0A1118] mb-10 max-w-2xl mx-auto text-center leading-relaxed">{iss.description}</p>}
        {(iss.articles || []).length === 0 ? (
          <div className="text-center py-16 font-serif text-[#001F3F]/60 border border-dashed border-gray-200">No articles in this issue.</div>
        ) : (
          (iss.articles || []).map((a) => <ArticleRow key={a.id} article={a} />)
        )}
      </div>
    </div>
  );
}
